<template>
  <h-s-pagination
    :current-page="currentPage"
    :total-pages="totalPages"
    :total-items="totalItems"
    :items-per-page="itemsPerPage"
    :per-page-options="perPageOptions"
    @previous-page="$emit('previous-page')"
    @next-page="$emit('next-page')"
    @update:itemsPerPage="$emit('update:itemsPerPage', $event)"
  />
</template>

<script>
import HSPagination from "@/components/table/HSPagination.vue";

export default {
  name: "HsPagination",
  components: { HSPagination },
  props: {
    currentPage: { type: Number, required: true },
    totalPages: { type: Number, required: true },
    totalItems: { type: Number, required: true },
    itemsPerPage: { type: Number, default: 10 },
    perPageOptions: { type: Array, default: () => [10, 25, 50, 100] },
  },
  emits: ["update:itemsPerPage", "previous-page", "next-page"],
};
</script>
